import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-fixed m-0 mx-3 p-0 total"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "col m-0 p-0" }
const _hoisted_4 = ["textContent"]

import { toRefs } from 'vue';

export interface ChartLegendItemPropsInterface {
  className?: string;
  title: string;
  total?: string;
  color?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartLegendItem',
  props: {
    className: {},
    title: {},
    total: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;
const { className, title, total, color } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid py-1 pl-1 w-full", _unref(className)]),
    style: _normalizeStyle({ color: _unref(color) })
  }, [
    (_unref(total))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "text-lg font-semibold",
            textContent: _toDisplayString(_unref(total))
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: "inline-block text-sm",
        style: {"margin-top":"2px"},
        textContent: _toDisplayString(_unref(title))
      }, null, 8, _hoisted_4)
    ])
  ], 6))
}
}

})